import { registerUser } from "../../../util/api";
import authenticate from "../../authentication";
import { startSession } from "../../session";
import { writeUserCredentialsToDb } from "../../../util/db";

export const REGISTATION_REQUEST = "REGISTATION_REQUEST";
const authRequest = () => ({
  type: REGISTATION_REQUEST,
  isLoading: true
});

export const REGISTATION_SUCCESS = "REGISTATION_SUCCESS";
const authSuccess = (accessToken, refreshToken) => ({
  type: REGISTATION_SUCCESS,
  isLoading: false,
  isSuccess: false,
  accessToken,
  refreshToken
});

export const REGISTATION_FAILURE = "REGISTATION_FAILURE";
const authFailure = msg => ({
  type: REGISTATION_FAILURE,
  isLoading: false,
  isSuccess: false,
  msg
});

const handleSuccesfullAttempt = (accessToken, refreshToken, dispatch) => {
  startSession(refreshToken, accessToken, dispatch);
  writeUserCredentialsToDb(accessToken, refreshToken);
  dispatch(authSuccess(accessToken, refreshToken));
  setTimeout(() => {
    dispatch(authenticate(true));
  }, 750);
};

const handleFailedAttempt = (errMsg, dispatch) => {
  dispatch(authFailure(errMsg));
};

export const registerUserWith = (
  email,
  managerName,
  username,
  password
) => dispatch => {
  // First dispatch: the app state is updated to inform
  // that the API call is starting.
  dispatch(authRequest());

  // The function called by the thunk middleware can return a value,
  // that is passed on as the return value of the dispatch method.
  // In this case, we return a promise to wait for.
  // This is not required by thunk middleware, but it is convenient for us.
  registerUser(email, managerName, username, password)
    .then(res => {
      const { accessToken, refreshToken } = res;
      setTimeout(
        () => handleSuccesfullAttempt(accessToken, refreshToken, dispatch),
        750
      );
    })
    .catch(err => {
      if (err.response) {
        handleFailedAttempt(err.response.data.msg, dispatch);
      } else {
        handleFailedAttempt("Something went wrong! 😱", dispatch);
      }
    });
};
